import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomCalendarRange = ({
    isClearable = false,
    className = "",
    holder = "Selecciona rango de fechas",
    valueStart = null,
    valueEnd = null,
    filters,
    setFilters,
}) => {
    const [dateRange, setDateRange] = useState([valueStart, valueEnd]);
    const [startDate, endDate] = dateRange;

    const onChange = (update) => {
        setDateRange(update);

        // Actualiza los filtros externos
        if (setFilters && typeof setFilters === "function") {
            setFilters({ ...filters, date_start: update[0], date_end: update[1], })
        }
    };

    return (
        <DatePicker
            selectsRange
            startDate={startDate}
            endDate={endDate}
            onChange={onChange}
            isClearable={isClearable}
            placeholderText={holder}
            className={`border rounded px-2 py-1 z-[9999] ${className}`}
            dateFormat="yyyy/MM/dd"
            
            popperClassName="z-[9999]" // 👈 z-index alto
        />
    );
};

export default CustomCalendarRange;
